<template>
  <div>
    <label>Cidade</label>

    <div class="w3-row">
      <div class="w3-col s4 l2">
        <input
          type="text"
          @keyup.enter="inserirDadoPorChave()"
          ref="chavePesquisa"
          class="w3-input w3-border input-codigo"
          v-model="chave_pesquisa"
          :disabled="somenteLeitura == 'S'"
          v-bind:placeholder="placeholder_codigo"
          v-on:blur="onBlurChave()"
          maxlength="15"/>
      </div>

      <div class="w3-col s8 l10">
        <div class="input-container">
          <input
            class="input-registro-selecionado w3-border"
            type="text"
            v-model="cidade_selecionada.nome"
            @click="abrirPesquisa()"
            :disabled="somenteLeitura == 'S'"
            placeholder="Clique para pesquisar"
            readonly/>

          <i
            v-if="somenteLeitura == 'N'"
            class="fas fa-minus icone w3-border-top w3-border-right w3-border-bottom"
            @click="limparDados"/>
        </div>
      </div>
    </div>

    <pesquisa-cidades
      ref="pesquisaCidades"
      @confirmar="carregar">
    </pesquisa-cidades>

  </div>
</template>

<script>
  import RCidade from '@/components/Rest/RCidade'
  import Biblioteca from '@/components/Repositorio/Biblioteca'
  import PesquisaCidades from '@/components/Pesquisas/PesquisaCidades'

  export default {
    name: 'FrameCidade',

    components: {
      PesquisaCidades
    },

    props: {
      somenteLeitura: {
        required: true,
        type: String,
        default: 'N'
      },

      cidadeSelecionada: {
        required: false,
        type: Object,
        default: function () {
          return {}
        }
      }
    },

    data() {
      return {
        cidade_selecionada: {},
        chave_pesquisa: '',
        placeholder_codigo: 'Cód.'
      }
    },

    methods: {
      async inserirDadoPorChave(chave) {

        if (this.valorInt(chave) > 0){
          this.chave_pesquisa = chave;
        }

        let cidade_id = this.valorInt(this.chave_pesquisa);

        if 
          (
            (this.chave_pesquisa == '') ||
            (cidade_id <= 0)
          )
        {
          Biblioteca.exclamar('Digite um código válido!');
          return;
        }  

        try {

          let parametros = {
            tipo: 'COD',
            chave: cidade_id
          }

          let retorno = await RCidade.pesquisarCidades(this.axios, parametros);
          if (retorno.houve_erro != 'N') {
            throw new Error(retorno.mensagem);
          }

          this.carregar(JSON.parse(JSON.stringify(retorno.dados[0])));
        }
        catch (e) {
          this.limparDados();
          Biblioteca.exclamar(e.message);
        }
      },

      abrirPesquisa() {
        this.$refs.pesquisaCidades.abrir();
      },

      carregar(cidade) {
        this.chave_pesquisa = '';

        if ((!cidade) || (!cidade.cidade_id)) {
          this.limparDados();
          return;
        }
        
        this.cidade_selecionada = JSON.parse(JSON.stringify(cidade));
        this.placeholder_codigo = Biblioteca.nPadrao(
          this.cidade_selecionada.cidade_id,
          0
        );

        this.$emit('confirmar', this.cidade_selecionada);
      },

      onBlurChave() {
        if (this.cidade_selecionada.cidade_id) {
          if (this.cidade_selecionada.cidade_id != this.valorInt(this.chave_pesquisa)) {
            this.chave_pesquisa = '';
          }
        }
        else {
          this.limparDados();
        }
      },

      limparDados() {
        this.chave_pesquisa = '';
        this.placeholder_codigo = 'Cód.';
        this.cidade_selecionada = {};
        this.$emit('limparDados');
      },

      selecao() {
        if (this.cidade_selecionada.cidade_id) {
          return this.cidade_selecionada;
        }

        return undefined;
      },

      valor(numero_str) {
        return Biblioteca.valor(numero_str);
      },

      valorInt(numero) {
        return Biblioteca.valorInt(numero);
      }
    },

    created() {
      if (this.cidadeSelecionada) {
        this.carregar(this.cidadeSelecionada);
      }
    }
  }
</script>

<style escoped>
  .card-item {
    background-color: #f3f3f3;
    border-radius: 10px;
    box-shadow: #f3f3f3 1px 3px 5px 3px ;
    margin-bottom: 5px;
    padding: 3px !important;
  }

  .input-codigo {
    padding: 10px 15px;
    border-radius: 0px;
    position: relative;
    z-index: 0;
    font-weight: bold;
    border-right-style: none!important;
  }

  .input-container {
    display: -ms-flexbox; 
    display: flex;
    position: relative;
    z-index: 1;
    margin-left: -20px;
    width: calc(100% + 20px);
  }

  .icone {
    padding: 11px;
    background: gray;
    color: white;
    min-width: 15px;
    text-align: center;
    border-left-style: none
  }

  .icone:active {
    background-color: #ccc;
    box-shadow: 0 1px #666;
    transform: translateY(1px);
  }

  .input-registro-selecionado {
    width: 100%;
    padding: 10px;
    outline: none;
    cursor: pointer;
    font-weight: bold;
    border-right-style: none;
  }

</style>


// WEBPACK FOOTER //
// src/components/Frames/FrameCidade.vue